module.exports = __webpack_public_path__ + "img/time-nutrition-1.4d8fb65.svg";